module.exports = __webpack_public_path__ + "static/media/bg-contact.4d2024b2.png";